import { render, staticRenderFns } from "./TaskUserDetails.vue?vue&type=template&id=29d0eb7a&"
import script from "./TaskUserDetails.vue?vue&type=script&lang=js&"
export * from "./TaskUserDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskUserDetails.vue?vue&type=style&index=0&id=29d0eb7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports